import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import axios from 'axios';
import { getApiUrl } from '../utils/apiUrl';
import ClientSignup from '../pages/ClientSignup';
import Smart404Router from './Smart404Router';

interface CompanyVerificationResponse {
  success: boolean;
  exists: boolean;
  companyName: string | null;
}

const CompanySignupWrapper: React.FC = () => {
  const { companySlug } = useParams<{ companySlug: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [companyExists, setCompanyExists] = useState<boolean | null>(null);

  useEffect(() => {
    const verifyCompany = async () => {
      if (!companySlug) {
        setCompanyExists(false);
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.get<CompanyVerificationResponse>(
          `${getApiUrl()}/api/companies/verify-slug/${companySlug}`
        );
        
        setCompanyExists(response.data.exists);
      } catch (error) {
        console.error('Error verifying company:', error);
        setCompanyExists(false);
      } finally {
        setIsLoading(false);
      }
    };

    verifyCompany();
  }, [companySlug]);

  if (isLoading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        sx={{
          backgroundColor: '#000011',
          color: '#ffffff'
        }}
      >
        <CircularProgress size={60} sx={{ color: '#ffffff', mb: 2 }} />
        <Typography variant="h6" sx={{ color: '#ffffff' }}>
          Verifying company...
        </Typography>
      </Box>
    );
  }

  if (companyExists === false) {
    // Company doesn't exist, show 404
    return <Smart404Router />;
  }

  if (companyExists === true) {
    // Company exists, show signup form
    return <ClientSignup />;
  }

  // Fallback (shouldn't reach here)
  return <Smart404Router />;
};

export default CompanySignupWrapper;
